import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import CreatePurchaseInvoice from '../../../components/PurchaseInvoice/CreatePurchaseInvoice.js';
import { useSearch } from '../../../contexts/SearchContext.js';

export default function NewPurchaseInvoice() {
  const navigate = useNavigate();
  const { resetListFilters } = useSearch();

  useEffect(() => {
    resetListFilters();
  }, [resetListFilters]);

  return (
    <AdminPageShell title="Nueva factura de compra" showSearch={false}>
      <CreatePurchaseInvoice
        onCreated={() => navigate('/admin/purchase-invoices')}
      />
    </AdminPageShell>
  );
}
